export enum SellerSidebarTab {
    ChooseProject,
    Project,
    Tasks,
    Products,
    ChangeRequests,
    Dialogs
}

export interface ISellerSideBarReducer {
    isOpen: boolean;
    selectedTab: SellerSidebarTab | null;
    subLabel: string | null;
}

const initialState: ISellerSideBarReducer = {
    selectedTab: null,
    isOpen: false,
    subLabel: null,
};

const sellerSidebar = (state = initialState, action) => {
    switch (action.type) {
        case 'SELLER_SIDEBAR_SET_IS_OPEN':
            return { ...state, isOpen: action.data };
        case 'SELLER_SIDEBAR_SET_SUB_LABEL':
            return { ...state, subLabel: action.data };
        case 'SELLER_SIDEBAR_SET_SELECTED_TAB':
            return { ...state, selectedTab: action.data };
        // Think this was added to make the sellerSidebar collapse when changing to buyer?
        // Anyway. Not sure if it's needed anymore
        // case 'SET_GLOBAL_ACTIVE_PROFILE':
        //     return { ...state, isOpen: false };
        default:
            return state;
    }
};

export default sellerSidebar;